import {
  APP_CODE_BRANCH,
  APP_CODE_ROOM,
  MAX_CONCURRENT_EXPANDED_BRANCHES,
} from "constants/constants";
import Summarised from "graphics/icons/BranchBar/Summarised";
import React from "react";
import { useSelector } from "react-redux";
import { selectData } from "slices/efficeCacheSlice";
import { selectCurrentActive } from "slices/efficeTreeSlice";
import BranchItem from "./BranchItem/BranchItem";

function countTree(tree) {
  let count = 0;
  for (let id in tree) {
    if (tree[id]) count += countTree(tree[id]);
    count++;
  }
  return count;
}

const Branch = ({ id, totalDepth, currentDepth, tree }) => {
  const isActive = useSelector((state) => selectCurrentActive(state) === id);
  const summarised =
    totalDepth - currentDepth >= MAX_CONCURRENT_EXPANDED_BRANCHES;
  const efficeData = useSelector((state) => selectData(state)[id]);

  const renderChildren = () => {
    let items = [];
    for (const id in tree) {
      items.push(
        <Branch
          key={id}
          id={id}
          totalDepth={totalDepth}
          currentDepth={currentDepth + 1}
          tree={tree[id]}
        />
      );
    }
    return items;
  };

  if (!efficeData) return null;
  return (
    <div
      style={{
        order:
          efficeData.app_id === APP_CODE_BRANCH
            ? "0"
            : efficeData.app_id === APP_CODE_ROOM
            ? "1"
            : "2",
      }}
    >
      <BranchItem
        id={id}
        efficeData={efficeData}
        key={id}
        isActive={isActive}
        isOpen={tree}
        // isDarkened={isDarkened}
      />
      <div
        className={`branch-list ${summarised ? "summarised" : ""}`}
        style={{
          height: countTree(tree) * 34 + "px",
          overflow: summarised ? "initial" : "hidden",
        }}
      >
        {summarised && (
          <div className="summarised-line">
            <Summarised />
          </div>
        )}
        {tree && renderChildren()}
      </div>
    </div>
  );
};

export default Branch;
